import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import IconWrapper from '@mlb/react-patterns/components/Icon/icon.tsx';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

import { Tracking } from 'bdvp-tracking';

const A = styled(Link)`
    display: inline-block;
    margin: 12px 0 13px 8px;
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    font-weight: 600;

    ${mainCq.lg`
        margin: 0 0 11px;
    `}
    body & {
        color: ${COLORS.mlbGrey3};
        &:hover {
            color: ${COLORS.mlbGrey3};
        }
    }
`;

const Icon = styled(IconWrapper)`
    margin: 0 5px 2px 0;
    vertical-align: middle;
`;

const BackToLink = () => {

    const location = useLocation();

    if (!location.state?.backToButton) {

        return null;

    }

    const { label, url } = location.state.backToButton;

    return (
        <A to={url} onClick={() => Tracking.trackBackToLinkClick(label)}>
            <Icon name={'carousel-arrow-left'} width={12} size={'md'}/>
            {label}
        </A>
    );

};

export default BackToLink;
